import React from "react";
import PrimeHoldingContainer from "containers/jarivsPrime/PrimeHolding";

const PrimeExistingHolding = (props) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <PrimeHoldingContainer />
      </div>
    </>
  );
};

export default PrimeExistingHolding;
